/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum DayOfWeek {
  Monday = "MONDAY",
  Tuesday = "TUESDAY",
  Wednesday = "WEDNESDAY",
  Thursday = "THURSDAY",
  Friday = "FRIDAY",
  Saturday = "SATURDAY",
  Sunday = "SUNDAY",
}

export function instanceOfDayOfWeek(value: any): boolean {
  for (const key in DayOfWeek) {
    if (Object.prototype.hasOwnProperty.call(DayOfWeek, key)) {
      if (DayOfWeek[key as keyof typeof DayOfWeek] === value) {
        return true;
      }
    }
  }
  return false;
}

export function DayOfWeekFromJSON(json: any): DayOfWeek {
  return DayOfWeekFromJSONTyped(json, false);
}

export function DayOfWeekFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): DayOfWeek {
  return json as DayOfWeek;
}

export function DayOfWeekToJSON(value?: DayOfWeek | null): any {
  return value as any;
}

export function DayOfWeekToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): DayOfWeek {
  return value as DayOfWeek;
}
